//
//
//
//
//
//
//
//
//

export default {
  props: {
    link: String,
    buttonText: String
  }
}
